import React, { useState } from 'react';
import { Link, useNavigate } from 'react-router-dom';
import { useAuth } from '../context/AuthContext';

const Login = () => {
  const [formData, setFormData] = useState({
    email: '',
    password: ''
  });
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState('');
  const { login } = useAuth();
  const navigate = useNavigate();

  const handleChange = (e) => {
    setFormData({
      ...formData,
      [e.target.name]: e.target.value
    });
    // Clear error when user starts typing
    if (error) setError('');
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    setLoading(true);
    setError('');

    try {
      const result = await login(formData);
      
      if (result.success) {
        navigate('/');
      } else {
        setError(result.message || 'Login failed');
      }
    } catch (error) {
      setError('An unexpected error occurred. Please try again.');
      console.error('Login error:', error);
    } finally {
      setLoading(false);
    }
  };

  return (
    <div style={{
      minHeight: '100vh',
      backgroundColor: '#f8f9fa',
      display: 'flex',
      alignItems: 'center',
      justifyContent: 'center',
      padding: 'clamp(10px, 3vw, 20px)'
    }}>
      <div style={{
        maxWidth: '450px',
        width: '100%',
        padding: 'clamp(30px, 8vw, 40px)',
        backgroundColor: 'white',
        borderRadius: '12px',
        boxShadow: '0 4px 6px rgba(0, 0, 0, 0.1)'
      }}>
        <h1 style={{
          fontSize: 'clamp(1.8rem, 5vw, 2.2rem)',
          fontWeight: 'bold',
          color: '#333',
          textAlign: 'center',
          marginBottom: 'clamp(20px, 5vw, 30px)'
        }}>
          Login
        </h1>

        {error && (
          <div style={{
            backgroundColor: '#f8d7da',
            color: '#721c24',
            padding: 'clamp(10px, 3vw, 15px)',
            borderRadius: '8px',
            marginBottom: 'clamp(15px, 3vw, 20px)',
            fontSize: 'clamp(0.9rem, 2.5vw, 1rem)',
            border: '1px solid #f5c6cb',
            display: 'flex',
            alignItems: 'center',
            gap: '8px'
          }}>
            <span style={{ fontSize: '1.2rem' }}>⚠️</span>
            {error}
          </div>
        )}

        <form onSubmit={handleSubmit}>
          <div style={{ marginBottom: 'clamp(15px, 3vw, 20px)' }}>
            <label style={{
              display: 'block',
              marginBottom: 'clamp(5px, 1vw, 8px)',
              fontSize: 'clamp(0.9rem, 2.5vw, 1rem)',
              fontWeight: '600',
              color: '#333'
            }}>
              Email
            </label>
            <input
              type="email"
              name="email"
              value={formData.email}
              onChange={handleChange}
              required
              style={{
                width: '100%',
                padding: 'clamp(10px, 3vw, 12px)',
                border: error ? '1px solid #dc3545' : '1px solid #ddd',
                borderRadius: '8px',
                fontSize: 'clamp(0.9rem, 2.5vw, 1rem)',
                boxSizing: 'border-box',
                transition: 'border-color 0.2s ease'
              }}
            />
          </div>

          <div style={{ marginBottom: 'clamp(15px, 3vw, 20px)' }}>
            <div style={{
              display: 'flex',
              justifyContent: 'space-between',
              alignItems: 'center',
              marginBottom: 'clamp(5px, 1vw, 8px)'
            }}>
              <label style={{
                display: 'block',
                fontSize: 'clamp(0.9rem, 2.5vw, 1rem)',
                fontWeight: '600',
                color: '#333'
              }}>
                Password
              </label>
              <Link
                to="/forgot-password"
                style={{
                  color: '#EDB404',
                  textDecoration: 'none',
                  fontSize: 'clamp(0.85rem, 2.2vw, 0.95rem)',
                  fontWeight: '500'
                }}
              >
                Forgot Password?
              </Link>
            </div>
            <input
              type="password"
              name="password"
              value={formData.password}
              onChange={handleChange}
              required
              style={{
                width: '100%',
                padding: 'clamp(10px, 3vw, 12px)',
                border: error ? '1px solid #dc3545' : '1px solid #ddd',
                borderRadius: '8px',
                fontSize: 'clamp(0.9rem, 2.5vw, 1rem)',
                boxSizing: 'border-box',
                transition: 'border-color 0.2s ease'
              }}
            />
          </div>

          <button
            type="submit"
            disabled={loading}
            style={{
              width: '100%',
              padding: 'clamp(12px, 3vw, 15px)',
              backgroundColor: loading ? '#6c757d' : '#EDB404',
              color: 'white',
              border: 'none',
              borderRadius: '8px',
              fontSize: 'clamp(1rem, 3vw, 1.1rem)',
              fontWeight: '600',
              cursor: loading ? 'not-allowed' : 'pointer',
              transition: 'all 0.2s ease',
              opacity: loading ? 0.7 : 1
            }}
            onMouseEnter={(e) => {
              if (!loading) {
                e.target.style.backgroundColor = '#d4a017';
                e.target.style.transform = 'translateY(-1px)';
              }
            }}
            onMouseLeave={(e) => {
              if (!loading) {
                e.target.style.backgroundColor = '#EDB404';
                e.target.style.transform = 'translateY(0)';
              }
            }}
          >
            {loading ? 'Logging in...' : 'Login'}
          </button>
        </form>

        <p style={{
          textAlign: 'center',
          marginTop: 'clamp(20px, 4vw, 30px)',
          fontSize: 'clamp(0.9rem, 2.5vw, 1rem)',
          color: '#666'
        }}>
          Don't have an account?{' '}
          <Link
            to="/register"
            style={{
              color: '#EDB404',
              textDecoration: 'none',
              fontWeight: '600'
            }}
          >
            Register
          </Link>
        </p>
      </div>
    </div>
  );
};

export default Login;
